import { Component } from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import { FaFile } from 'react-icons/fa'
import { ReplaceProposalFileContainer } from 'components/common/ReplaceProposalFileContainer'
import s from './ReplaceFile.scss'

@connect()
class ReplaceFile extends Component {
  state = {
    showReplaceFileModal: false
  }

  toggleReplaceFileModal = () => {
    this.setState(prevState => ({
      showReplaceFileModal: !prevState.showReplaceFileModal
    }))
  }

  render() {
    const { proposal } = this.props
    const { showReplaceFileModal } = this.state
    return (
      <>
        <Button className={s.fileBtn} onClick={this.toggleReplaceFileModal}>
          <FaFile />
          Replace File
        </Button>
        <ReplaceProposalFileContainer
          proposal={proposal}
          showReplaceFileModal={showReplaceFileModal}
          toggleReplaceFileModal={this.toggleReplaceFileModal}
        />
      </>
    )
  }
}

export default ReplaceFile
